//@flow
import { gql, graphql } from "react-apollo"
import type { AttractLoopFormViewProps } from "../types"

const QUERY_ATTRACT_LOOP_DETAILS = gql`
  query GetAttractLoopDetails($id: ID!) {
    attractLoop(id: $id) {
      id
      title
    }
  }
`
const skip = (props: AttractLoopFormViewProps): boolean =>
  typeof props.match.params.id === "undefined"

const options = (props: AttractLoopFormViewProps) => ({
  variables: {
    id: props.match.params.id
  }
})

const withAttractLoopFormDetails = graphql(QUERY_ATTRACT_LOOP_DETAILS, {
  options,
  skip,
  name: "details"
})

export default withAttractLoopFormDetails



// WEBPACK FOOTER //
// ./src/AttractLoops/queries/withAttractLoopFormDetails.js